module.exports = __webpack_public_path__ + "static/murah-wisata-bangkok-9a6ffb91412d37af7d416ec56f6fe329.png";